// extracted by mini-css-extract-plugin
export default {"registration__form-container-wrapper":"Auth_registration__form-container-wrapper__SebhH","name__link":"Auth_name__link__ewHyr"};